import { render, staticRenderFns } from "./SepaSettings.vue?vue&type=template&id=da840526&scoped=true"
import script from "./SepaSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./SepaSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/settings/styles/settings-styles.css?vue&type=style&index=0&id=da840526&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da840526",
  null
  
)

/* custom blocks */
import block0 from "@/components/settings/locales/i18n-sepa-settings.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fsettings%2FSepaSettings.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports